var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "questions" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.formattedQuestions, function(question) {
        return _c("Question", {
          key: question.title,
          attrs: {
            title: question.title,
            question: question.question,
            lastAsked: question.metadata.lastAsked,
            frequency: question.metadata.frequency
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "question-header" }, [
      _c("div", { staticClass: "question-title" }, [
        _vm._v("\n\t\t\tTitle\n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "last-asked" }, [_vm._v("\n\t\t\tAsked\n\t\t")]),
      _vm._v(" "),
      _c("div", { staticClass: "frequency" }, [
        _vm._v("\n\t\t\tFrequency\n\t\t")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-716e592a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-716e592a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questions/Questions.vue
// module id = null
// module chunks = 